import { render } from "./DobUnder18CheckDialog.vue?vue&type=template&id=b56d2508&scoped=true"
import script from "./DobUnder18CheckDialog.vue?vue&type=script&lang=js"
export * from "./DobUnder18CheckDialog.vue?vue&type=script&lang=js"

import "./DobUnder18CheckDialog.vue?vue&type=style&index=0&id=b56d2508&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b56d2508"]])

export default __exports__